module.exports = __webpack_public_path__ + "static/defaultCoverIntegrations-4ba919f937ae0f0a2755467e6df92172.png";